import React from 'react';
import { Container } from 'react-bootstrap';
import './Accessibility.css';

export const Accessibility = () => (
  <Container fluid className="accessibility-container">

    <div className="accessibility-page">


        <div className="accessibility-card">

          <div className="accessibility-decorator"></div>

          <div className="accessibility-content">

            {/* =====================================================
                HEADER
            ===================================================== */}

            <p className="accessibility-highlight">
              בהתאם לחוק הנגישות, לשם קבלת היתר זמני, רישיון עסק או חידוש רישיון:
            </p>

            <h1 className="accessibility-main-title">
              נגישות לעסקים: המדריך המלא לקבלת רישיון עסק כחוק
            </h1>

            <p className="accessibility-main-text">
              ערים מסוימות מחייבות את העסקים לעמוד בדרישות הנגישות בהתאם לחוק
              <span className="accessibility-bold-blue">
                {' '}שוויון זכויות לאנשים עם מוגבלויות{' '}
              </span>
              ותקנותיו.
            </p>


            {/* =====================================================
                INFO BOX
            ===================================================== */}

            <div className="accessibility-info-box">

              <p className="accessibility-intro-text">
                מתכננים לפתוח עסק חדש? צריכים לחדש את רישיון העסק הקיים
                או לקבל היתר זמני?
                <strong>
                  {' '}עמידה בחוק הנגישות היא כבר מזמן לא המלצה –
                  היא תנאי סף מחייב לקבלת רישיון עסק בישראל.
                </strong>
              </p>

              <p className="accessibility-info-text">
                על פי חוק שוויון זכויות לאנשים עם מוגבלויות,
                כל עסק המעניק שירות לציבור מחויב להנגיש את המקום
                ואת השירות בצורה מלאה. הרשויות המקומיות אוכפות
                דרישה זו בקפידה, ובלי אישור נגישות רשמי,
                לא ניתן לקבל רישיון עסק.
              </p>

              <p className="accessibility-info-text">
                כדי לעבור את התהליך בהצלחה וללא עיכובים,
                עליכם להגיש לרשות המקומית חוות דעת מקצועיות
                משני מורשי נגישות:
              </p>


              {/* =====================================================
                  EXPERT 1
              ===================================================== */}

              <div className="accessibility-expert-box">

                <div className="accessibility-expert-number">
                  1
                </div>

                <div className="accessibility-expert-content">

                  <h3 className="accessibility-expert-title">
                    מורשה נגישות מתו"ס
                  </h3>

                  <p className="accessibility-small-text">
                    מבנים, תשתיות וסביבה
                  </p>

                  <p className="accessibility-info-text">
                    מורשה מתו"ס אחראי על כל המרכיבים הפיזיים
                    וההנדסיים של המבנה. הוא בוחן את דרך הגישה
                    של הלקוח מרגע הגעתו ועד לכניסתו לעסק.
                  </p>

                  <h4 className="accessibility-sub-title">
                    מה הוא בוחן בשטח?
                  </h4>

                  <ul className="accessibility-list">
                    <li>חניות נכים</li>
                    <li>שיפועים ורמפות בכניסה</li>
                    <li>רוחב פתחים ודלתות</li>
                    <li>מעברים פנימיים חופשיים ממכשולים</li>
                    <li>התאמה מלאה של תאי השירותים</li>
                  </ul>

                </div>

              </div>


              {/* =====================================================
                  EXPERT 2
              ===================================================== */}

              <div className="accessibility-expert-box">

                <div className="accessibility-expert-number">
                  2
                </div>

                <div className="accessibility-expert-content">

                  <h3 className="accessibility-expert-title">
                    מורשה נגישות השירות
                  </h3>

                  <p className="accessibility-info-text">
                    מורשה השירות מתמקד בחוויית הלקוח וברמת
                    הנגישות של השירות הניתן בתוך העסק,
                    מעבר לקירות המבנה.
                  </p>

                  <h4 className="accessibility-sub-title">
                    מה הוא בוחן בשטח?
                  </h4>

                  <ul className="accessibility-list">
                    <li>גובה דלפקי שירות וקופות</li>
                    <li>התאמת ריהוט, כמו שולחנות נגישים</li>
                    <li>מערכות עזר לשמיעה, כגון לולאות השראה</li>
                    <li>שילוט ברור ומכוון</li>
                    <li>נגישות אתר האינטרנט של העסק</li>
                    <li>הדרכות ייעודיות לצוות העובדים למתן שירות נגיש</li>
                  </ul>

                </div>

              </div>


              {/* =====================================================
                  PROCESS
              ===================================================== */}

              <div className="accessibility-process-section">

                <h3 className="accessibility-section-title">
                  איך עובד תהליך האישור מול הרשות המקומית?
                </h3>


                <div className="accessibility-process-item">

                  <span className="accessibility-process-number">
                    01
                  </span>

                  <div>

                    <strong className="accessibility-process-title">
                      בדיקת המסמכים
                    </strong>

                    <p className="accessibility-small-info-text">
                      מורשה נגישות מטעם הרשות יבחן את חוות הדעת
                      ויוודא שהן עומדות בלשון החוק ובדרישות הדין.
                    </p>

                  </div>

                </div>


                <div className="accessibility-process-item">

                  <span className="accessibility-process-number">
                    02
                  </span>

                  <div>

                    <strong className="accessibility-process-title">
                      ביקורת פיזית
                    </strong>

                    <p className="accessibility-small-info-text">
                      נציגי הרשות יגיעו לסיור פיקוח בעסק כדי
                      לוודא שכל הפתרונות שתוכננו אכן בוצעו
                      בשטח במאת האחוזים.
                    </p>

                  </div>

                </div>


                <div className="accessibility-process-item">

                  <span className="accessibility-process-number">
                    03
                  </span>

                  <div>

                    <strong className="accessibility-process-title">
                      מתן האישור
                    </strong>

                    <p className="accessibility-small-info-text">
                      רק לאחר קבלת אישור ממורשה הנגישות של
                      הרשות, תוכלו להתקדם לקבלת היתר זמני,
                      רישיון עסק או חידוש הרישיון הקיים.
                    </p>

                  </div>

                </div>

              </div>


              {/* =====================================================
                  GOLDEN TIP
              ===================================================== */}

              <div className="accessibility-golden-tip">

                <div className="accessibility-tip-icon">
                  ★
                </div>

                <div>

                  <h3 className="accessibility-tip-title">
                    טיפ זהב לבעלי עסקים
                  </h3>

                  <p className="accessibility-tip-text">
                    אל תחכו לרגע האחרון. מומלץ לערב מורשה
                    נגישות כבר בשלב התכנון הראשוני של העסק,
                    לפני השיפוץ, כדי למנוע טעויות בנייה קריטיות
                    שתיקונן בשטח עלול לעלות לכם הרבה מאוד כסף
                    וזמן יקר.
                  </p>

                </div>

              </div>

            </div>


            {/* =====================================================
                REQUIREMENTS
            ===================================================== */}

            <div className="accessibility-requirements-section">

              <h3 className="accessibility-section-title">
                מה נדרש מבעל העסק?
              </h3>

              <div className="accessibility-items">


                <div className="accessibility-item">

                  <div className="accessibility-icon">
                    ✓
                  </div>

                  <div>

                    <strong className="accessibility-item-title">
                      בדיקת נגישות
                    </strong>

                    <p className="accessibility-item-text">
                      בחינת העסק והתאמתו לדרישות הנגישות
                      הקבועות בחוק ובתקנות.
                    </p>

                  </div>

                </div>


                <div className="accessibility-item">

                  <div className="accessibility-icon">
                    ✓
                  </div>

                  <div>

                    <strong className="accessibility-item-title">
                      חוות דעת מקצועית
                    </strong>

                    <p className="accessibility-item-text">
                      קבלת חוות דעת ממורשי נגישות מוסמכים
                      בהתאם לסוג העסק ולדרישות הרשות.
                    </p>

                  </div>

                </div>


                <div className="accessibility-item">

                  <div className="accessibility-icon">
                    ✓
                  </div>

                  <div>

                    <strong className="accessibility-item-title">
                      עמידה בדרישות החוק
                    </strong>

                    <p className="accessibility-item-text">
                      ביצוע ההתאמות הנדרשות לצורך קבלת היתר,
                      רישיון עסק או חידושו.
                    </p>

                  </div>

                </div>

              </div>

            </div>


            {/* =====================================================
                BOTTOM NOTE
            ===================================================== */}

            <div className="accessibility-bottom-note">

              <span className="accessibility-note-icon">
                💡
              </span>

              <span>
                חשוב לבצע את הבדיקה מראש, כדי למנוע עיכובים
                בתהליך קבלת הרישיון.
              </span>

            </div>

          </div>

        </div>


    </div>

  </Container>
);